module.exports = __webpack_public_path__ + "img/供餐-4.67512962.jpg";